/**
 * @description Helper to get data attributes from div entry point
 */

const chatRootElement = document.getElementById('innso-chat') || {
  dataset: { tenantSid: null, configSid: null, url: null, layer: 'dataLayer' },
}
const {
  tenantSid,
  configSid,
  url,
  layer = 'dataLayer',
} = chatRootElement.dataset // get data- attributes

const baseURL = process.env.NODE_ENV === 'development' ? '/' : url

const urlWithouTraillingSlash = baseURL?.replace(/\/$/, '')

export default Object.freeze({
  tenantSid,
  configSid,
  url,
  layer,
  urlWithouTraillingSlash,
})
